export default __webpack_public_path__ + "static/media/005-launcher-1.bc55ffdc.png";